<ce-level-menu-base>
    @if (isOrganizationSettingsActive()) {
    <a routerLink="/organization-settings" routerLinkActive="CeLevelMenuItem--selected" [ce-popover-trigger-for]="orgSwitchMenu" (popoverOpened)="orgSwitchRef($event)" ce-popover-position="right">
        <ce-name-display [name]="orgName()" class="CeLevelMenuItem-label">
            <ce-icon svgIcon="grid" />
        </ce-name-display>
    </a>
    } @else {
    <button [ce-popover-trigger-for]="orgSwitchMenu" (popoverOpened)="orgSwitchRef($event)" [disabled]="isLoading()" ce-popover-position="right">
        <ce-name-display [name]="orgName()" class="CeLevelMenuItem-label">
            @if (isLoading()) {
            <ce-spinning-loader-sm />
            } @else {
            <ce-icon svgIcon="grid" />
            }
        </ce-name-display>
    </button>
    }
</ce-level-menu-base>

<ce-popover-overlay #orgSwitchMenu="cePopoverOverlay">
    <ce-popover class="OrganizationSwitcher-container">
        <ce-app-org-switch-popover (orgSwitchEvent)="orgSwitchEvent($event)" />
    </ce-popover>
</ce-popover-overlay>
